import { useCallback, useMemo, useRef, useState } from "react";
import styled from "styled-components";
import arrow from "@/lib/assets/Polygon.svg"

type Props = {
    items: any[]
    selectedIndex: number
    labelName?: string
    changeIndex: (item: any, index: number) => void
    width?: number
}

const SelectItemV2 = (props: Props) => {
    const [showModal, setShowModal] = useState(false)
    const toggleSelector = useCallback(() => {
        setShowModal(!showModal)
    }, [showModal])

    const selectedText = useMemo(() => {
        if(props.selectedIndex > -1) {
            const item = props.items[props.selectedIndex]
            if(item) {
                return item[props.labelName ?? "name"]
            }
        }
        return "--選択してください--"
    }, [props.items, props.labelName, props.selectedIndex])

    const onSelected = useCallback((item: any, index: number) => {
        props.changeIndex(item, index)
        setShowModal(false)
    }, [props])
    

    return (
        <SelectItemV2Style
            style={{width: `${props.width ?? 200}px`}}
        >
            <div 
                className="selector" 
                onClick={toggleSelector}
                style={{
                    width: `${props.width ?? 200}px`
                }}
            >
                <p 
                    className="selector-text"
                    style={{width: `${(props.width ?? 200) - 30}px`}}
                >{selectedText}</p>
                <div className="select-arrow"></div>
            </div>
            {
                showModal && (
                    <>
                        <div className="select-modal-overlay" onClick={toggleSelector}>
                        </div>
                        <div className="select-modal" style={{width: `${props.width ?? 200}px`}}>
                            {
                                props.items.map((item, index) => (
                                    <p 
                                        className="select-modal-option"
                                        onClick={() => {onSelected(item, index)}}
                                    >
                                        {item[props.labelName ?? "name"]}
                                    </p>
                                ))
                            }
                        </div>
                    </>
                )
            }
        </SelectItemV2Style>
    )
}

export default SelectItemV2

const SelectItemV2Style = styled.div`
position: relative;
    .selector {
        color: black;
        position: relative;
        cursor: pointer;
        border-bottom: 1px solid;
        border-color: #7c7a7a;
        display: flex;
        justify-content: center;
        height: 30px;
        &:hover {
            border-width: 2px;
        }
        .select-arrow {
            width: 30px;
            height: 30px;
            background-image: url(${arrow});
            background-repeat: no-repeat;
            background-size: 10px;
            background-position: center;
        }
    }
    .select-modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        height: 100vh;
        width: 100vw;
        z-index: 99998;
    }
    .select-modal {
        position: absolute;
        top: 30px;
        left: 0;
        max-height: 300px;
        overflow-y: scroll;
        background-color: white;
        box-shadow: black 0px 0px 10px;
        border-radius: 8px;
        z-index: 99999;
        .select-modal-option {
            color: black;
            width: 100%;
            padding: 8px 16px 8px 16px;
            border-bottom: 1px solid #c0bcbc;
            cursor: pointer;
            &:hover {
                background-color: #c0bcbc;
            }
            &:first-child {
                border-radius: 8px 8px 0 0;
            }
            &:last-child {
                border-bottom: none;
                border-radius: 0 0 8px 8px;
            }
        }
    }
`